// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".notificationDetails{min-height:300px}", "",{"version":3,"sources":["/home/jenkins/agent/workspace/dashboard_gsa/src/components/notification/NotificationDetails.vue"],"names":[],"mappings":"AAqCA,qBACE,gBAAA","file":"NotificationDetails.vue","sourcesContent":["@import \"@/styles/_variables.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.notificationDetails {\n  min-height: 300px;\n}\n"]}]);
// Exports
module.exports = exports;
